import { IHocPhanMienActionTypes } from "../../action-types/hoc-phan-mien/hocPhanMienActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IHocPhanMienReducer } from "../../reducer-model/hoc-phan-mien/IHocPhanMienReducer";

const iniState: IHocPhanMienReducer = {
    status: eReducerStatusBase.is_not_initialization,
    focusedValueLop: undefined,
    hoSoSinhViens: [],
    hocPhanMiens: [],
    sinhVienSelectedIds: [],
    monMienSelectedIds: [],
    isShowThemHocPhanMienModal: false,
    id_dt_selected: [],
}

export const hocPhanMienReducer = (state: IHocPhanMienReducer = iniState, action: IHocPhanMienActionTypes): IHocPhanMienReducer => {
    switch (action.type) {
        case "HOC_PHAN_MIEN_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "HOC_PHAN_MIEN_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                hocPhanMiens: action.payload,
            };
        case "HOC_PHAN_MIEN_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "HOC_PHAN_MIEN_CHANGE_FOCUSED_VALUE_LOP":
            return {
                ...state,
                focusedValueLop: action.payload,
            };
        case "HOC_PHAN_MIEN_LOAD_HO_SO_SINH_VIEN_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "HOC_PHAN_MIEN_LOAD_HO_SO_SINH_VIEN_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                hoSoSinhViens: action.payload,
            };
        case "HOC_PHAN_MIEN_LOAD_HO_SO_SINH_VIEN_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "HOC_PHAN_MIEN_INSERTS_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "HOC_PHAN_MIEN_INSERTS_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "HOC_PHAN_MIEN_INSERTS_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "HOC_PHAN_MIEN_DELETES_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "HOC_PHAN_MIEN_DELETES_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "HOC_PHAN_MIEN_DELETES_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "HOC_PHAN_MIEN_SINH_VIEN_SELECTED_IDS_CHANGE":
            return {
                ...state,
                sinhVienSelectedIds: action.payload,
            };
        case "HOC_PHAN_MIEN_MON_MIEN_SELECTED_IDS_CHANGE":
            return {
                ...state,
                monMienSelectedIds: action.payload,
            };
        case "HOC_PHAN_MIEN_SHOW_THEM_HOC_PHAN_MIEN_MODAL":
            return {
                ...state,
                isShowThemHocPhanMienModal: true,
                id_dt_selected: action.payload,
            };
        case "HOC_PHAN_MIEN_CLOSE_THEM_HOC_PHAN_MIEN_MODAL":
            return {
                ...state,
                isShowThemHocPhanMienModal: false,
                id_dt_selected: [],
            };
    }
    return state;
}